import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExternalRoutingModule } from './external-routing.module';
import { CalculatorsModule } from '../../calculators/calculators.module';

import { RootExternalComponent } from './root-external.component';
import { CalculatorWrapComponent } from './calculators/calculator.component';
import { OptionsCalculatorWrapComponent } from './calculators/options-calculator.component';
import { ProbabilityCalculatorWrapComponent } from './calculators/probability-calculator.component';
import { SharedModule } from "@iv/shared/shared.module";

@NgModule({
  declarations: [
    RootExternalComponent,
    CalculatorWrapComponent, OptionsCalculatorWrapComponent, ProbabilityCalculatorWrapComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ExternalRoutingModule,
    CalculatorsModule,
  ]
})
export class ExternalModule { }
